import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "./BurnHistory.css";
//const [globenft , setglobenft] = useState([]);
var config = require("../../src/config/dev").default;




function BurnHistory(){
    // let viewnfts = [];
    const [viewnfts,setviewnfts] = useState([]);
    let utcTimestamp = ""
    let localDate = "";
    let localTime = "";
    const pathname = window.location.pathname;
    const tokenId = pathname.split('/').pop().split('=')[1];
    console.log("tokenId", tokenId);

    useEffect(()=>{
        
        const fetchTransactions = async () => {
            
            // Fetch transaction history using Moralis API
            const response = await fetch(config.API_ENDPOINT+'src/v1/eprAsset/eprnft/vieweprnft?token_id='+tokenId, {
              method: "get",
              headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
            });
            const result = await response.json();
            const viewnftres = result.data.result;
            console.log("viewnftres", viewnftres);
            
            // Filter out burn NFT transactions
            // const burnTransactions = viewnftres.map(transaction => {
                
            // // console.log('transaction', transaction);
            // // //   return transaction.to_address === "0x0000000000000000000000000000000000000000";
            // //   if(transaction.to_address == "0x0000000000000000000000000000000000000000"){
            // //     console.log('transactionburn', transaction);
            // //     // viewnfts.push(transaction); // Set burn NFT transactions to state or variable
            // //     // setviewNfts(transaction);// Set burn NFT transactions to state or variable
                
            // //     const burntrans = [transaction];
            // //     viewnfts.push(burntrans);
            // //     setviewNfts(burntrans);
            // //     console.log("viewnfts",viewnfts);
            // //   }
            // });   
            // Filter out burn NFT transactions
        const burnTransactions = viewnftres.filter(transaction => transaction.to_address === "0x0000000000000000000000000000000000000000");

        setviewnfts(burnTransactions);
             console.log("view",viewnfts)
          };
        
          fetchTransactions();
       
    },[]
    
    );

    return(
        <><div><Navbar></Navbar>
        </div><div className="row my-4">
                <div className="row">


                    <div className="col-11" style={{ margin: "50px auto" }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 750 }} style={{ border: 1 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="left" style={{ width: 100, fontSize: "13px" }}><b>Token ID</b></TableCell>
                                        <TableCell className= "address" align="left" style={{ fontSize: "13px" }}><b>From Address</b></TableCell>
                                        <TableCell align="left" style={{  fontSize: "13px" }}><b>To Address</b></TableCell>
                                        <TableCell align="left" style={{  fontSize: "13px" }}><b>Amount</b></TableCell>
                                        <TableCell align="left" style={{  fontSize: "13px" }}><b>Date and Time</b></TableCell>
                                        {/* <TableCell align="left" style={{ width: 200, fontSize: "13px" }}><b>Owner Address</b></TableCell> */}
                                    </TableRow>
                                </TableHead>

                                
                                <TableBody>

                                
                                {viewnfts.map((nft, index) => (
                                    console.log("viewnfts",viewnfts),
                                    // console.log("nft",nft),
                                    // Convert ytc block_timestamp to local time
                                    utcTimestamp = new Date(nft.block_timestamp),
                                    localDate = utcTimestamp.toLocaleDateString(),
                                    localTime = utcTimestamp.toLocaleTimeString(),
                                    console.log("localTimestamp",localDate , localTime),
                                    <TableRow key= {index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="left" style={{ fontSize: "13px" }}>{nft.token_id}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "13px" }}><span className="address">{nft.from_address}</span></TableCell>
                                        <TableCell className= "address" align="left" style={{ fontSize: "13px" }}>{nft.to_address}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "13px" }}>{nft.amount}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "13px" }}>{localDate} {localTime}</TableCell>
                                    </TableRow>

                                ))}

                                </TableBody>


                            </Table>
                        </TableContainer>

                    </div>

                </div>
            </div></>
)

}

export default BurnHistory;